module.exports = __webpack_public_path__ + "img/d-max-en.87736356.png";